var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.simpleName),expression:"simpleName"}],staticClass:"home"},[_c('div',{staticStyle:{"padding-top":"50px","text-align":"center"}},[_vm._v(" 正在保存，稍后将跳转返回 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }